<script>
import GenreOptions from '@components/genre/genre-options'

export default {
    name: 'GenreGridTile',
    components: { GenreOptions },
    props: {
        genre: {
            type: Object,
            default: () => {},
        },
        isOnSelectMode: {
            type: Boolean,
            default: false
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        isFollowing: {
            type: Boolean,
            default: false
        },
        hasOptions: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        slug() {
            return this.genre.slug
        },
    },
    methods: {
        handleToggleFollow() {
            this.$emit('toggle-follow', this.genre)
        },
    }
}
</script>

<template>
    <div
        :title="`Discover ${genre.name} music`"
        class="genre-tile"
        :class="{ 'select-mode': isOnSelectMode }"
    >
        <div
            v-if="genre"
            class="genre-tile-wrapper"
        >
            <div
                class="genre-tile-container"
                :class="{ 'select-mode': isOnSelectMode, 'is-selected': isSelected }"
            >
                <BaseLink
                    v-if="slug"
                    :to="isOnSelectMode ? { name: this.$route.name } : { name: 'genre', params: { slug: slug } }"
                >
                    <BaseResourceImage
                        :resource="genre"
                        type="artwork"
                        class="genre-tile-image"
                        :fill="false"
                    />
                </BaseLink>
                <BaseResourceImage
                    v-else
                    :resource="genre"
                    type="artwork"
                    class="genre-tile-image"
                    :fill="false"
                />
                <div class="genre-tile-title">
                    {{ genre.name }}
                </div>
            </div>
            <div
                v-if="hasOptions"
                class="genre-tile-options"
                @click.prevent="() => {}"
            >
                <BaseDropdown :padded="false">
                    <BaseButton
                        slot="trigger"
                        :modifiers="{ autoWidth: true, transparent: true, dots: true }"
                        aria-label="Options"
                        button-type="tag"
                        size="small"
                    />
                    <div slot="dropdown">
                        <GenreOptions
                            :genre="genre"
                            :is-following="isFollowing"
                            @toggle-follow="handleToggleFollow"
                        />
                    </div>
                </BaseDropdown>
            </div>
        </div>
        <BasePlaceholder
            v-else
            class="genre-tile-title"
            :text="genre && genre.name"
            type="genre"
            tag="div"
        />
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.genre-tile {
    &.select-mode {
        pointer-events: none;
    }
}

.genre-tile-wrapper {
    position: relative;
}

.genre-tile-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    overflow: hidden;
    border: 2px solid $c-grey-mine-shaft;
    border-radius: $s-l;

    &.select-mode {
        pointer-events: all;
    }

    &.is-selected {
        border-color: $c-highlight;
        box-shadow: 0 0 $s-m 0 $c-highlight;
    }

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        pointer-events: none;
        content: '';
        background: $c-purple-red-gradient;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }
}

.genre-tile-wrapper:hover {
    .genre-tile-container::after {
        opacity: 0.5;
    }

    .genre-tile-options {
        opacity: 1;
    }

    .genre-tile-image {
        transform: scale(1.1);
    }
}

.genre-tile-image {
    align-self: end;
    font-size: 0;
    transition: transform 0.3s;
}

.genre-tile-options {
    position: absolute;
    top: $s-m;
    right: $s-m;
    z-index: $layer-dropdown-z-index + 10;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
}

.genre-tile-title {
    @extend %contentTitleL;

    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    width: 90%;
    line-height: 24px;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
    pointer-events: none;
    transform: translate(-50%, -50%);
}

@include desktop {
    .genre-tile-container {
        height: 200px;
    }

    .genre-tile-options {
        opacity: 0;
    }
}
</style>
